<template>
  <div class="initial-loader">
    <div class="loader-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="258" height="258" viewBox="0 0 258 258">
        <g id="Grupo_326" data-name="Grupo 326" transform="translate(6163 11134)">
          <g id="Grupo_322" data-name="Grupo 322" transform="translate(-6255 -11404)">
            <g id="Grupo_1" data-name="Grupo 1" transform="translate(92 270)">
              <rect
                id="Rectángulo_1"
                data-name="Rectángulo 1"
                width="258"
                height="258"
                rx="129"
                transform="translate(0)"
                fill="#294380"
              />
            </g>
          </g>
          <g id="Grupo_325" data-name="Grupo 325" transform="translate(-6438.217 -12233.536)">
            <g id="Grupo_324" data-name="Grupo 324" transform="translate(412.369 1156.536)">
              <path
                id="Trazado_21"
                data-name="Trazado 21"
                d="M813.217,1228.419,766.3,1299.152a2.11,2.11,0,0,1-1.765.846H726.7c-1.5,0-2.464-1.267-1.765-2.322l45.94-69.258-45.948-69.564c-.7-1.055.267-2.319,1.766-2.319h37.834a2.109,2.109,0,0,1,1.766.848l46.919,71.035Z"
                transform="translate(-724.7 -1156.536)"
                fill="#fff"
              />
            </g>
            <path
              id="Trazado_22"
              data-name="Trazado 22"
              d="M353.2,1322.737a59.471,59.471,0,0,0,42.755-1.2,58.6,58.6,0,0,0,31.354-31.353,59.307,59.307,0,0,0,0-45.789,58.6,58.6,0,0,0-31.354-31.353,59.307,59.307,0,0,0-45.789,0,58.6,58.6,0,0,0-31.353,31.353,58.51,58.51,0,0,0-4.6,22.895v71.345a.873.873,0,0,0,.873.873h20.321a.873.873,0,0,0,.873-.873v-23.593a.872.872,0,0,1,1.4-.7A58.885,58.885,0,0,0,353.2,1322.737Zm-14.068-69.786a37.3,37.3,0,0,1,19.584-19.584,36.678,36.678,0,0,1,40.364,7.907,38.612,38.612,0,0,1,7.908,11.677,37.516,37.516,0,0,1,0,28.687,38.575,38.575,0,0,1-7.908,11.677,37.065,37.065,0,0,1-40.364,7.907,37.3,37.3,0,0,1-19.584-19.584,37.515,37.515,0,0,1,0-28.687Z"
              transform="translate(0 -39.5)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
      <p v-if="mode === 'development'">{{ text }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PwLoading',
  data() {
    return {
      user: null,
      module: process.env.VUE_APP_MODULE,
      mode: process.env.NODE_ENV,
      text: 'Cargando...',
    };
  },
  mounted() {
    this.generateContext();
  },
  methods: {
    ...mapActions('User', ['setUser']),

    setLogger(message) {
      this.text = message;
    },
    async generateContext() {
      this.setLogger('Autentificando usuario');
      await this.setUser()
        .then((user) => {
          this.user = user;
          this.setLogger(`Usuario auntentificado ${this.user.profile.UserName}`);
          this.loadTenantInfo();
        })
        .catch(() => {
          this.setLogger('Usuario no loggeado');
        });
    },
    async loadTenantInfo() {
      this.$emit('loaded', true);
    },
  },
};
</script>

<style lang="scss">
.initial-loader {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 10000;
  align-items: center;
  justify-content: center;
}
.loader-content {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  p {
    text-align: center;
    font-size: 12px;
  }
  img,
  svg {
    width: 150px;
    height: 150px;
    animation: pulse 1s infinite;
    border-radius: 50%;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(41, 67, 128, 0.4);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(41, 67, 128, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(41, 67, 128, 0);
  }
}
</style>
